import { useEffect, useState } from "react";
import http from "@/lib/api";
import { Panel, Table, Td, Empty } from "./AdminKit";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Trash2, Pencil } from "lucide-react";

const empty = { template_key: "", subject_template: "", body_template: "", language: "no", is_active: true };

export default function AdminEmailTemplates() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(empty);
  const [editId, setEditId] = useState(null);

  const load = () => http.get("/v1/admin/email-templates").then((r) => setRows(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.template_key.trim() || !form.subject_template.trim()) { toast.error("Заполните ключ и тему"); return; }
    try {
      if (editId) await http.put(`/v1/admin/email-templates/${editId}`, form);
      else await http.post("/v1/admin/email-templates", form);
      toast.success("Сохранено"); setOpen(false); setForm(empty); setEditId(null); load();
    } catch { toast.error("Ошибка"); }
  };
  const edit = (r) => { setForm({ template_key: r.template_key, subject_template: r.subject_template, body_template: r.body_template, language: r.language || "no", is_active: r.is_active !== false }); setEditId(r.id); setOpen(true); };
  const remove = async (id) => { if (!window.confirm("Удалить шаблон?")) return; try { await http.delete(`/v1/admin/email-templates/${id}`); toast.success("Удалено"); load(); } catch { toast.error("Ошибка"); } };

  return (
    <div className="space-y-6" data-testid="admin-email-templates">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-white">Шаблоны email</h1>
        <Button className="bg-blue-600 hover:bg-blue-700 text-white gap-2" onClick={() => { setForm(empty); setEditId(null); setOpen(true); }}><Plus className="h-4 w-4" />Новый шаблон</Button>
      </div>
      <div className="bg-slate-800 border border-slate-700 rounded-lg p-4 text-slate-400 text-sm">
        Переменные в фигурных скобках: {"{{customer_name}}, {{job_code}}, {{customer_code}}, {{brand}}, {{model}}, {{estimated_cost}}, {{approval_link}}, {{message}}"}. Отправка через Gmail SMTP (симуляция без GMAIL_APP_PASSWORD).
      </div>
      <Panel title={`Всего: ${rows.length}`}>
        {rows.length === 0 ? <Empty /> : (
          <Table head={["Ключ", "Тема", "Язык", "Активен", "Действия"]}>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-slate-700/50">
                <Td>{r.template_key}</Td><Td className="max-w-md">{r.subject_template}</Td><Td>{r.language}</Td><Td>{r.is_active !== false ? "да" : "нет"}</Td>
                <Td><div className="flex gap-2"><button onClick={() => edit(r)} className="text-blue-400 hover:text-blue-300"><Pencil className="h-4 w-4" /></button><button onClick={() => remove(r.id)} className="text-red-400 hover:text-red-300"><Trash2 className="h-4 w-4" /></button></div></Td>
              </tr>
            ))}
          </Table>
        )}
      </Panel>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-slate-800 border-slate-700 text-white max-h-[90vh] overflow-y-auto">
          <DialogHeader><DialogTitle>{editId ? "Редактировать шаблон" : "Новый шаблон"}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><label className="text-sm text-slate-300">Ключ шаблона *</label><Input value={form.template_key} onChange={(e) => setForm({ ...form, template_key: e.target.value })} className="mt-1 bg-slate-700 border-slate-600 text-white" /></div>
            <div><label className="text-sm text-slate-300">Тема *</label><Input value={form.subject_template} onChange={(e) => setForm({ ...form, subject_template: e.target.value })} className="mt-1 bg-slate-700 border-slate-600 text-white" /></div>
            <div><label className="text-sm text-slate-300">Текст</label><Textarea value={form.body_template} onChange={(e) => setForm({ ...form, body_template: e.target.value })} rows={8} className="mt-1 bg-slate-700 border-slate-600 text-white" /></div>
            <label className="flex items-center gap-2 text-sm text-slate-300"><input type="checkbox" checked={form.is_active} onChange={(e) => setForm({ ...form, is_active: e.target.checked })} />Активен</label>
          </div>
          <DialogFooter><Button className="bg-blue-600 hover:bg-blue-700 text-white" onClick={save}>Сохранить</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
